import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

/** Shared portfolio report shape for bulk rebalance lookups and tables. */
export const BULK_REBALANCE_PORTFOLIO_REPORT_FIELDS = `
  id
  modelPortfolioType
  baseCurrency
  originalCurrencies
  cashCents
  expectedCashCents
  expectedCashPercentage
  driftRebalanceRequired
  liquidateRebalanceRequired
  transferRebalanceRequired
  pendingSubTradeRequests
  modelPortfolio {
    id
    translatedName {
      ${TRANSLATED_STRING_FIELDS}
    }
  }
  subAccounts {
    marketValueCents
    currency
    accountBaseCurrency
    cashCents
    expectedCashCents
    cashOnHoldToTradeCents
    pendingWithdrawCents
    pendingContributionCents
    originalValues {
      currency
      cashCents
      expectedCashCents
      cashAvailableForTradeCents
      marketValueCents
      pendingWithdrawCents
      pendingContributionCents
      cashOnHoldToTradeCents
    }
    subAccount {
      id
      state
      account {
        taxRank
        type
        user {
          firstName
          entityName
        }
      }
    }
    holdings {
      quantity
      valueCents
      expectedValueCents
      expectedPercentage
      adjustedCostBaseCents
      financialProduct {
        id
        ticker
      }
    }
  }
  holdings {
    taxRank
    quantity
    currency
    valueCents
    expectedValueCents
    expectedPercentage
    financialProduct {
      id
      ticker
      originalCurrency
      currentPriceCents
      taxRank
      settlementDays
      translatedName {
        ${TRANSLATED_STRING_FIELDS}
      }
    }
  }
  object {
    ... on Goal {
      id
      __typename
      name
      statistics {
        marketValueCents
      }
      householdClientGroup {
        id
        name
      }
      user {
        id
        firstName
        lastName
        entityName
      }
    }
    ... on SubAccount {
      id
      __typename
      statistics {
        marketValueCents
      }
      goal {
        id
        name
      }
      account {
        user {
          id
          firstName
          lastName
          entityName
        }
      }
    }
    ... on ClientGroup {
      id
      clientGroupName: name
      __typename
    }
  }
`;
